// The content of a toast that can take its action back: the message, then the
// undo link. react-toastify passes `closeToast`.
const UndoToast = ({ message, undoLabel, onUndo, closeToast }) => (
  <div className="flex items-center justify-between gap-4">
    <span>{message}</span>
    <button
      type="button"
      onClick={() => {
        onUndo();
        closeToast?.();
      }}
      className="shrink-0 font-medium underline underline-offset-2"
    >
      {undoLabel}
    </button>
  </div>
);

export default UndoToast;
